/** Single place that knows URL shapes (PRD §9). Use these instead of string literals. */
export const paths = {
  home: () => '/',
  shops: (q?: { category?: string; sort?: string }) => withQuery('/shops', q),
  category: (slug: string) => `/category/${slug}`,
  /** `tag` = a shop tag slug: its products are listed first (BR-22). */
  shop: (slug: string, q?: { tag?: string | null }) =>
    withQuery(`/shop/${slug}`, q?.tag ? { tag: q.tag } : undefined),
  product: (id: number, slug?: string) => (slug ? `/product/${id}-${slug}` : `/product/${id}`),
  search: (q?: { q?: string; tab?: 'products' | 'shops' }) => withQuery('/search', q),
  /** A curated page (D-92); `group` = one shelf. */
  collection: (slug: string, q?: { group?: string }) => withQuery(`/collections/${slug}`, q),
  /** A Home section's See all page (D-96). */
  section: (code: string) => `/section/${code}`,
  cart: () => '/cart',
  privacy: () => '/privacy',
} as const

/** "/product/12-mens-linen-shirt" param → 12 */
export function parseProductId(idSlug: string | undefined): number | null {
  const id = Number.parseInt(idSlug ?? '', 10)
  return Number.isFinite(id) && id > 0 ? id : null
}

function withQuery(path: string, q?: Record<string, string | undefined>): string {
  if (!q) return path
  const params = new URLSearchParams(
    Object.entries(q).filter((e): e is [string, string] => Boolean(e[1])),
  ).toString()
  return params ? `${path}?${params}` : path
}
